import qs from 'qs';
import ireader from '@ireader/jssdk';
import 'core-js/modules/es.array.slice.js';
import 'core-js/modules/es.regexp.exec.js';
import 'core-js/modules/es.string.replace.js';
import 'core-js/modules/es.string.split.js';
import 'core-js/modules/es.array.join.js';
import 'core-js/modules/es.object.freeze.js';
import { sha256 } from 'js-sha256';
import Request from '@ireader/request';
import 'core-js/modules/es.symbol.js';
import 'core-js/modules/es.symbol.description.js';
import 'core-js/modules/es.object.to-string.js';
import 'core-js/modules/es.symbol.iterator.js';
import 'core-js/modules/es.array.iterator.js';
import 'core-js/modules/es.string.iterator.js';
import 'core-js/modules/web.dom-collections.iterator.js';

var ua = navigator.userAgent;
var Orientation;
(function (Orientation) {
    // 横屏
    Orientation["LANDSCAPE"] = "landscape";
    // 竖屏
    Orientation["PORTRAIT"] = "portrait";
    // 未获取
    Orientation["UNKNOWN"] = "unknown";
})(Orientation || (Orientation = {}));
var Device = /** @class */ (function () {
    function Device() {
    }
    Device.isWeixin = function () {
        return /MicroMessenger/i.test(ua);
    };
    // 是否为掌阅App
    Device.isIreaderApp = function () {
        if (this.isAndroid() && window.ZhangYueJS) {
            return true;
        }
        else if (this.isIos() && ua.match(/.*AppleWebKit(?!.*Safari)/i) && !this.isAlipay()) {
            return true;
        }
        return false;
    };
    Device.isAlipay = function () {
        return ua.indexOf('AlipayClient') > 0;
    };
    Device.isIos = function () {
        return this.isSafari();
    };
    Device.isAndroid = function () {
        return /(Android);?[\s/]+([\d.]+)?/.test(ua);
    };
    Device.isIpad = function () {
        /*
         * ipad环境判断更新
         * IOS13以后ipad更新了ua，所以iOS13以前通过ua判断,13及以后通过platform、maxTouchPoints判断
         * navigator.platform属性被废弃害怕有风险，所以用Mac匹配浏览器ua做兜底方案
         * 风险是如果电脑设备支持触摸会将Mac电脑识别为pad
        **/
        return /(iPad).*OS\s([\d_]+)/.test(ua) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1) || (/Mac/i.test(ua) && navigator.maxTouchPoints > 1);
    };
    Device.isIpod = function () {
        return /(iPod)(.*OS\s([\d_]+))?/.test(ua);
    };
    Device.isIphone = function () {
        return /(iPhone\sOS)\s([\d_]+)/.test(ua);
    };
    Device.isChrome = function () {
        return ua.toLowerCase().indexOf('chrome') >= 0;
    };
    Device.isSafari = function () {
        return this.isIphone() || this.isIpod() || this.isIpad();
    };
    // 判断是否支持localStorage
    Device.isSupportLocalStorage = function () {
        return localStorage && typeof localStorage.getItem === 'function';
    };
    // 判断是否支持sessionStorage
    Device.isSupportSessionStorage = function () {
        return sessionStorage && typeof sessionStorage.getItem === 'function';
    };
    // 获取客户端版本号
    Device.getAppVersion = function () {
    };
    Device.windowWidth = function () {
        return window.innerWidth || 0;
    };
    Device.windowHeight = function () {
        return window.innerHeight || 0;
    };
    Device.screenDensity = function () {
        return window.devicePixelRatio;
    };
    Device.screen = function () {
        return window.screen || {};
    };
    Device.isWifi = function () {
        var _a, _b;
        return ((_b = (_a = window.navigator) === null || _a === void 0 ? void 0 : _a.connection) === null || _b === void 0 ? void 0 : _b.type) === 'wifi';
    };
    Device.networkType = function () {
        var _a, _b;
        return ((_b = (_a = window.navigator) === null || _a === void 0 ? void 0 : _a.connection) === null || _b === void 0 ? void 0 : _b.type) || 'unknown';
    };
    /**
     * @description: 获取当前设备方向
     * @return {string} unknown | portrait | landscape
     */
    Device.getOrientation = function () {
        var _a, _b, _c;
        var orientation;
        orientation = (_c = (_b = (_a = screen === null || screen === void 0 ? void 0 : screen.orientation) === null || _a === void 0 ? void 0 : _a.type) === null || _b === void 0 ? void 0 : _b.match(/(.+)-/)) === null || _c === void 0 ? void 0 : _c[1];
        if (!orientation) {
            var windowOrientation = Math.abs(window.orientation);
            if (windowOrientation === 90) {
                orientation = Orientation.LANDSCAPE;
            }
            if (windowOrientation === 0 || windowOrientation === 180) {
                orientation = Orientation.PORTRAIT;
            }
        }
        if (!orientation) {
            if (this.windowWidth > this.windowHeight) {
                orientation = Orientation.LANDSCAPE;
            }
            if (this.windowHeight > this.windowWidth) {
                orientation = Orientation.PORTRAIT;
            }
        }
        return orientation || Orientation.UNKNOWN;
    };
    return Device;
}());

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

var safeJsonStringify = function (str, defaultValue) {
    if (defaultValue === void 0) { defaultValue = ''; }
    try {
        if (str instanceof Error) {
            return str.message;
        }
        return JSON.stringify(str);
    }
    catch (e) {
        return defaultValue;
    }
};
/**
 * 防抖函数 https://github.com/jashkenas/underscore/blob/master/underscore.js
 * @param  {function} func     需要防抖的函数
 * @param  {number} wait       触发等待的时间
 * @param  {boolean} immediate 连续事件到来，尽量立即触发
 * @return {function}          返回加入防抖的函数
 * @demo debounce(func, wait, false)
 */
var debounce = function (func, wait, immediate) {
    var timeout;
    return function () {
        var args = arguments;
        var self = this;
        if (timeout)
            clearTimeout(timeout);
        if (immediate) {
            var callNow = !timeout;
            timeout = setTimeout(function () {
                timeout = null;
            }, wait);
            if (callNow)
                func.apply(self, args);
        }
        else {
            timeout = setTimeout(function () {
                func.apply(self, args);
            }, wait);
        }
    };
};
/**
 * @description: 把url解析出 path(path = origin + pathname) query hash
 * @param url {string} URL格式的一个字符串
 * @return {Object}
 */
var breakDownUrl = function (url) {
    if (url === void 0) { url = ''; }
    // 匹配锚点
    var _a = url.match(/#(.+)/) || [], _b = _a[1], hash = _b === void 0 ? '' : _b;
    // 匹配query参数
    var _c = url.match(/\?([^#]+)/) || [], _d = _c[1], search = _d === void 0 ? '' : _d;
    // 匹配path 自定义 path = origin + pathname
    var path = url.replace(/#.+/, '').split('?')[0];
    return {
        path: path,
        search: search,
        hash: hash
    };
};

var Url = /** @class */ (function () {
    function Url() {
    }
    /**
     * 获取页面所有参数
     *  在单页面应用路由为hash模式下的location.search会返回空字符串，所以通过?切割location.href进行获取query参数
     *  示例: https://sandbox.zhi3.net/annual-report/twenty-two.html#/index?zysid=0d831307814c65fcedfadf7ef1af13aa&usr=a10258
     */
    Url.getParams = function () {
        var _a = location.href.split('?'), _b = _a[1], searchStr = _b === void 0 ? '' : _b;
        // 去掉hash
        searchStr = searchStr.replace(/#.*/g, '');
        return qs.parse(searchStr) || {};
    };
    /**
     * 获取url上指定参数的值
     * @param key
     */
    Url.getParam = function (key) {
        var queryParams = this.getParams();
        return queryParams[key];
    };
    /**
     * @description: 检测url上是否有指定参数
     * @param key {string}
     * @return {Boolean}
     */
    Url.hasParam = function (key) {
        var queryParams = this.getParams();
        return Object.keys(queryParams).includes(key);
    };
    /**
     * 不刷新页面更新页面参数
     * @param key
     * @param value
     */
    Url.updateParam = function (key, value) {
        var queryParams = this.getParams();
        var newQueryParams = __assign(__assign({}, queryParams), { key: value });
        window.history.replaceState({}, window.document.title, window.location.href.split('?')[0] + '?' + qs.stringify(newQueryParams));
    };
    /**
     * 不刷新页面删除页面参数
     * @param key
     */
    Url.removeParam = function (key) {
        var queryParams = this.getParams();
        // eslint-disable-next-line no-prototype-builtins
        if (queryParams.hasOwnProperty(key)) {
            delete queryParams[key];
        }
        window.history.replaceState({}, window.document.title, window.location.href.split('?')[0] + '?' + qs.stringify(queryParams));
    };
    /**
     * 为指定的地址添加参数 参数优先级 paramsObject > path > location.href
     * @param path
     * @param paramsObject
     * @param options
     */
    Url.assignParam = function (path, paramsObject, options) {
        if (paramsObject === void 0) { paramsObject = {}; }
        if (options === void 0) { options = {}; }
        var _a = options.withLocationParams, withLocationParams = _a === void 0 ? false : _a;
        var _b = breakDownUrl(path), originPath = _b.path, originParams = _b.search, hash = _b.hash;
        // 获取url的参数
        var queryParams = withLocationParams ? this.getParams() : {};
        var params = Object.assign({}, queryParams, this.queryParse(originParams), paramsObject);
        var url = originPath;
        if (qs.stringify(params).length) {
            url += "?".concat(qs.stringify(params));
        }
        if (hash) {
            url += "#".concat(hash);
        }
        return url;
    };
    /**
     * 透传 qs的stringify方法
     * @param obj
     */
    Url.queryStringify = function (obj) {
        return qs.stringify(obj);
    };
    /**
     * 透传 qs的parse方法
     * @param str
     */
    Url.queryParse = function (str) {
        return qs.parse(str) || {};
    };
    return Url;
}());

var getUrl = function (url, params) {
    if (params === void 0) { params = {}; }
    var _a = url.split('?'), fullUrl = _a[0], search = _a[1];
    var paramsInUrl = qs.parse(search);
    return fullUrl + '?' + qs.stringify(__assign(__assign({}, paramsInUrl), params));
};
var getUrlWithOriginParams = function (url, params) {
    var queryParams = Url.getParams();
    // php路由参数ca remove掉
    if (queryParams.ca) {
        delete queryParams.ca;
    }
    return getUrl(url, __assign(__assign({}, Url.getParams()), params));
};
var Router = /** @class */ (function () {
    function Router() {
    }
    /**
     * 页面跳转
     * @param url
     * @param params
     * @param options
     */
    Router.navigateTo = function (url, params, options) {
        if (options === void 0) { options = {}; }
        var _a = options.withParams, withParams = _a === void 0 ? true : _a;
        if (withParams) {
            location.href = getUrlWithOriginParams(url, params);
        }
        else {
            location.href = getUrl(url, params);
        }
    };
    /**
     * 页面重定向
     * @param url
     * @param params
     * @param options
     */
    Router.redirectTo = function (url, params, options) {
        if (options === void 0) { options = {}; }
        var _a = options.withParams, withParams = _a === void 0 ? true : _a;
        if (withParams) {
            location.replace(getUrlWithOriginParams(url, params));
        }
        else {
            location.replace(getUrl(url, params));
        }
    };
    /**
     * 页面后退
     * @param delta: 后退几个历史记录
     */
    Router.navigateBack = function (delta) {
        if (delta === void 0) { delta = 1; }
        window.history.go(delta * -1);
    };
    /**
     * 【客户端专用】新开一个webview打开新页面
     * @param url
     * @param params
     * @param options
     */
    Router.launchNewPageTo = function (url, params, options) {
        if (params === void 0) { params = {}; }
        if (options === void 0) { options = {}; }
        return Router.navigateTo(url, __assign(__assign({}, params), { launch: 'newpage' }), options);
    };
    /**
     * 【客户端专用】切换底Tab
     * @param tab tab名
     */
    Router.switchTab = function (tab) {
        return ireader.goTab({ tab: tab });
    };
    return Router;
}());

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function getDefaultExportFromCjs (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

var js_cookie = {exports: {}};

(function (module, exports) {

  (function (global, factory) {
    module.exports = factory() ;
  })(commonjsGlobal, function () {
    /* eslint-disable no-var */

    function assign(target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          target[key] = source[key];
        }
      }

      return target;
    }
    /* eslint-enable no-var */

    /* eslint-disable no-var */


    var defaultConverter = {
      read: function read(value) {
        if (value[0] === '"') {
          value = value.slice(1, -1);
        }

        return value.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
      },
      write: function write(value) {
        return encodeURIComponent(value).replace(/%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g, decodeURIComponent);
      }
    };
    /* eslint-enable no-var */

    /* eslint-disable no-var */

    function init(converter, defaultAttributes) {
      function set(key, value, attributes) {
        if (typeof document === 'undefined') {
          return;
        }

        attributes = assign({}, defaultAttributes, attributes);

        if (typeof attributes.expires === 'number') {
          attributes.expires = new Date(Date.now() + attributes.expires * 864e5);
        }

        if (attributes.expires) {
          attributes.expires = attributes.expires.toUTCString();
        }

        key = encodeURIComponent(key).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
        var stringifiedAttributes = '';

        for (var attributeName in attributes) {
          if (!attributes[attributeName]) {
            continue;
          }

          stringifiedAttributes += '; ' + attributeName;

          if (attributes[attributeName] === true) {
            continue;
          } // Considers RFC 6265 section 5.2:
          // ...
          // 3.  If the remaining unparsed-attributes contains a %x3B (";")
          //     character:
          // Consume the characters of the unparsed-attributes up to,
          // not including, the first %x3B (";") character.
          // ...


          stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
        }

        return document.cookie = key + '=' + converter.write(value, key) + stringifiedAttributes;
      }

      function get(key) {
        if (typeof document === 'undefined' || arguments.length && !key) {
          return;
        } // To prevent the for loop in the first place assign an empty array
        // in case there are no cookies at all.


        var cookies = document.cookie ? document.cookie.split('; ') : [];
        var jar = {};

        for (var i = 0; i < cookies.length; i++) {
          var parts = cookies[i].split('=');
          var value = parts.slice(1).join('=');

          try {
            var foundKey = decodeURIComponent(parts[0]);
            jar[foundKey] = converter.read(value, foundKey);

            if (key === foundKey) {
              break;
            }
          } catch (e) {}
        }

        return key ? jar[key] : jar;
      }

      return Object.create({
        set: set,
        get: get,
        remove: function remove(key, attributes) {
          set(key, '', assign({}, attributes, {
            expires: -1
          }));
        },
        withAttributes: function withAttributes(attributes) {
          return init(this.converter, assign({}, this.attributes, attributes));
        },
        withConverter: function withConverter(converter) {
          return init(assign({}, this.converter, converter), this.attributes);
        }
      }, {
        attributes: {
          value: Object.freeze(defaultAttributes)
        },
        converter: {
          value: Object.freeze(converter)
        }
      });
    }

    var api = init(defaultConverter, {
      path: '/'
    });
    /* eslint-enable no-var */

    return api;
  });
})(js_cookie);

var jsCookie = js_cookie.exports;

var valueMaps = {};
// 原生localStorage的封装
var OriginLocalStorage = /** @class */ (function () {
    function OriginLocalStorage(storage) {
        this.storage = storage;
    }
    OriginLocalStorage.prototype.get = function (key, _a) {
        var _b = _a === void 0 ? {} : _a, _c = _b.serialize, serialize = _c === void 0 ? true : _c;
        if (serialize) {
            var value = this.storage.getItem(key);
            try {
                return JSON.parse(value);
            }
            catch (_) {
                /* istanbul ignore next */
                return value;
            }
        }
        return this.storage.getItem(key);
    };
    OriginLocalStorage.prototype.set = function (key, value, _a) {
        var _b = _a === void 0 ? {} : _a, _c = _b.serialize, serialize = _c === void 0 ? true : _c;
        if (serialize) {
            return this.storage.setItem(key, JSON.stringify(value));
        }
        return this.storage.setItem(key, value);
    };
    OriginLocalStorage.prototype.remove = function (key) {
        return this.storage.removeItem(key);
    };
    OriginLocalStorage.prototype.clear = function () {
        return this.storage.clear();
    };
    return OriginLocalStorage;
}());
// sessionStorage的polyfill版本
var PolyfillStorage = /** @class */ (function () {
    function PolyfillStorage() {
    }
    PolyfillStorage.prototype.get = function (key) {
        // eslint-disable-next-line
        if (valueMaps.hasOwnProperty(key)) {
            return valueMaps[key];
        }
        return null;
    };
    PolyfillStorage.prototype.set = function (key, value, _a) {
        var _b = _a === void 0 ? {} : _a, _c = _b.serialize, serialize = _c === void 0 ? true : _c;
        if (serialize) {
            return valueMaps[key] = value;
        }
        return valueMaps[key] = String(value);
    };
    PolyfillStorage.prototype.remove = function (key) {
        delete valueMaps[key];
    };
    PolyfillStorage.prototype.clear = function () {
        valueMaps = {};
    };
    return PolyfillStorage;
}());
// localStorage的polyfill版本
var PolyfillLocalStorage = /** @class */ (function () {
    function PolyfillLocalStorage() {
        this.storage = Storage.cookies;
    }
    PolyfillLocalStorage.prototype.get = function (key, _a) {
        var _b = _a === void 0 ? {} : _a, _c = _b.serialize, serialize = _c === void 0 ? true : _c;
        if (serialize) {
            var value = this.storage.get(key);
            try {
                return JSON.parse(value);
            }
            catch (_) {
                return value;
            }
        }
        return this.storage.get(key);
    };
    PolyfillLocalStorage.prototype.set = function (key, value, _a) {
        var _b = _a === void 0 ? {} : _a, _c = _b.serialize, serialize = _c === void 0 ? true : _c;
        if (serialize) {
            return this.storage.set(key, JSON.stringify(value));
        }
        return this.storage.set(key, value);
    };
    PolyfillLocalStorage.prototype.remove = function (key) {
        return this.storage.remove(key);
    };
    PolyfillLocalStorage.prototype.clear = function () {
    };
    return PolyfillLocalStorage;
}());
function Storage() { }
Storage.local = Device.isSupportLocalStorage() ? new OriginLocalStorage(localStorage) : new PolyfillLocalStorage();
Storage.session = Device.isSupportSessionStorage() ? new OriginLocalStorage(sessionStorage) : new PolyfillStorage();
Storage.cookies = jsCookie.withAttributes({ sameSite: '.zhangyue.com' });

var LOG_LEVEL = {
    INFO: 'info',
    ERROR: 'error'
};
var Trace = /** @class */ (function () {
    function Trace() {
    }
    Trace.addLog = function (category, level, messagePrefix, message) {
        if (category === void 0) { category = 'debug.log'; }
        if (messagePrefix === void 0) { messagePrefix = ''; }
        if (message === void 0) { message = 'default'; }
        var logMessage = typeof message === 'string' ? message : safeJsonStringify(message);
        try {
            if (process.env.VUE_APP_ENV !== 'production') {
                console.log("[".concat(category, "]:"), messagePrefix + '\n' + logMessage);
            }
            // @ts-ignore
            Sentry === null || Sentry === void 0 ? void 0 : Sentry.addBreadcrumb({
                category: category,
                message: messagePrefix + '\n' + logMessage,
                level: level
            });
        }
        catch (e) {
            return undefined;
        }
    };
    Trace.addInfoLog = function (category, messagePrefix, message) {
        return Trace.addLog(category, LOG_LEVEL.INFO, messagePrefix, message);
    };
    Trace.addErrorLog = function (category, messagePrefix, message) {
        return Trace.addLog(category, LOG_LEVEL.ERROR, messagePrefix, message);
    };
    Trace.triggerLogUpload = function (level, message) {
        if (level === void 0) { level = LOG_LEVEL.INFO; }
        if (message === void 0) { message = '前端debug log'; }
        // @ts-ignore
        Sentry === null || Sentry === void 0 ? void 0 : Sentry.captureMessage(message, { level: level });
    };
    return Trace;
}());

var Sign = /** @class */ (function () {
    function Sign() {
    }
    Sign.handlesRequestParams = function (data) {
        var _a, _b;
        if (data === void 0) { data = {}; }
        var requestParams = '';
        // ascii码排序
        (_b = (_a = Object.keys(data || {})) === null || _a === void 0 ? void 0 : _a.sort(function (x1, x2) {
            // 跟后台统一 不转大写
            // const x1 = a?.toUpperCase();
            // const x2 = b?.toUpperCase();
            if (x1 < x2)
                return -1;
            if (x1 > x2)
                return 1;
            return 0;
        })) === null || _b === void 0 ? void 0 : _b.map(function (key, index) {
            var _value = function (symbol) {
                if (symbol === void 0) { symbol = ''; }
                if (Array.isArray(data[key])) {
                    // 防止出现两个一样参数  临时方案，后续会有其他解决方案
                    return "".concat(symbol).concat(key, "[0]=").concat(data[key][0], "&").concat(key, "[1]=").concat(data[key][1]);
                }
                return "".concat(symbol).concat(key, "=").concat(data[key]);
            };
            requestParams += index < 1 ? _value() : _value('&');
        });
        return requestParams;
    };
    /**
     * 签名方式
     * @param config  axios 请求头参数集合
     */
    Sign.getSignNonce = function (config) {
        var _a, _b, _c;
        var url = ((_a = config.url) === null || _a === void 0 ? void 0 : _a.split('?')) || [];
        var requestUri = url[0];
        if (config.method === 'get') {
            requestUri += this.handlesRequestParams(__assign(__assign({}, config.params), qs === null || qs === void 0 ? void 0 : qs.parse(url[1])));
        }
        if (config.method === 'post') {
            // form 表单提交格式加密跟 get 一样
            if (((_b = config.headers['Content-Type']) === null || _b === void 0 ? void 0 : _b.toLocaleLowerCase().includes('x-www-form-urlencoded')) && typeof config.data === 'string') {
                requestUri += this.handlesRequestParams(__assign(__assign({}, qs.parse(config.data)), qs.parse(url[1])));
            }
            else {
                var requestJson = this.handlesRequestParams(qs === null || qs === void 0 ? void 0 : qs.parse(url[1])) + JSON.stringify(config.data);
                requestUri += requestJson;
            }
        }
        var tmpStr = (_c = sha256(requestUri)) === null || _c === void 0 ? void 0 : _c.substring(9, 25); // 截取9到25之间的
        var timeNow = parseInt(new Date().getTime() / 1000 + ''); // 秒级
        var nonce = timeNow.toString(16);
        var sign = sha256(tmpStr + timeNow);
        config.headers['X-Nonce'] = nonce;
        config.headers['X-Sign'] = sign;
        return { nonce: nonce, sign: sign };
    };
    return Sign;
}());

var URL_ENV;
(function (URL_ENV) {
    URL_ENV["PROD"] = "prod";
    URL_ENV["SANDBOX"] = "sandbox";
})(URL_ENV || (URL_ENV = {}));
var SANDBOX_BASE_URL = 'https://efe-sdd.tos-cn-beijing.volces.com/';
var PROD_BASE_URL = 'https://s-efe-sdd-h.zhangyuecdn.com';
var PROD_ENV = 'production';
var ERROR_MSG = '获取数据失败';
var b64ToUtf8 = function (str) {
    return JSON.parse(decodeURIComponent(escape(window.atob(str))));
};
var Sdd = /** @class */ (function () {
    function Sdd() {
    }
    /**
     * 根据环境、浏览器生成实际请求地址
     * @param pagePath sdd文件地址
     * @returns
     */
    Sdd.buildJsonPath = function (pagePath) {
        // 线上环境
        if (Sdd.env === PROD_ENV) {
            // 浏览器支持atob，请求加密文件
            if (window.atob) {
                return "/".concat(URL_ENV.PROD, "/").concat(pagePath);
            }
            else {
                return "/".concat(URL_ENV.PROD, "/").concat(pagePath, ".raw");
            }
        }
        // 测试环境
        else {
            return "/".concat(URL_ENV.SANDBOX, "/").concat(pagePath);
        }
    };
    /**
     *
     * @param pagePath sdd文件地址
     * @returns
     */
    Sdd.get = function (pagePath) {
        return __awaiter(this, void 0, void 0, function () {
            var jsonPath, baseURL, httpSilence, res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!pagePath) {
                            return [2 /*return*/, Promise.reject({ msg: '请传入请求sdd地址' })];
                        }
                        jsonPath = Sdd.buildJsonPath(pagePath);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        baseURL = Sdd.env === PROD_ENV ? PROD_BASE_URL : SANDBOX_BASE_URL;
                        httpSilence = new Request({ baseURL: baseURL }, {
                            noRepeatRequest: true
                        });
                        return [4 /*yield*/, httpSilence.get(jsonPath)];
                    case 2:
                        res = _a.sent();
                        if (Sdd.env === PROD_ENV && window.atob) {
                            return [2 /*return*/, b64ToUtf8(res)];
                        }
                        return [2 /*return*/, res];
                    case 3:
                        _a.sent();
                        return [2 /*return*/, Promise.reject({ msg: ERROR_MSG })];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    Sdd.env = process.env.VUE_APP_ENV;
    return Sdd;
}());

/**
 * 屏幕滚动到底的vue mixin
 * 使用方式：https://q7w8vltyes.feishu.cn/wiki/wikcnBPXnjm7j5A1qmphmuSOstg?table=tbl6v9i1TluOYgQN&view=vew7FN9YLx
 *
 // 在xxx.vue中
 import {reachBottom} from '@ireader/core-lib/mixins'

 export default {
    // 注！！！reachBottom是高阶函数，执行后返回新的mixin对象
    mixins: [reachBottom({delay: 200, preHeigth: 100})]
    methods: {
        // 需要在methods中定义 onReachBottom方法。屏幕滚动时触及底部时会被执行
        onReachBottom() {
        // 屏幕触底后你的处理写在此处
        }
    }
}
 */
var addScrollListener = function (fn) {
    window.addEventListener('scroll', fn);
};
var removeScrollListener = function (fn) {
    window.removeEventListener('scroll', fn);
};
var onScrollIntoBottom = function (preHeight, delay) {
    if (preHeight === void 0) { preHeight = 0; }
    if (delay === void 0) { delay = 200; }
    return debounce(function () {
        var body = window.document.documentElement || window.document.body;
        var scrollTop = window.pageYOffset || body.scrollTop;
        var viewHeight = body.clientHeight;
        var scrollHeight = body.scrollHeight;
        if (scrollTop + viewHeight >= scrollHeight - preHeight && typeof this.onReachBottom === 'function') {
            this.onReachBottom();
        }
    }, delay);
};
function reachBottom (options) {
    if (options === void 0) { options = {}; }
    var delay = options.delay || 200;
    var preHeight = options.preHeight || 50;
    return {
        created: function () {
            addScrollListener(onScrollIntoBottom(preHeight, delay).bind(this));
        },
        beforeDestroy: function () {
            removeScrollListener(onScrollIntoBottom(preHeight, delay).bind(this));
        }
    };
}

function onResume () {
    return {
        mounted: function () {
            var _this = this;
            window.onResume = function () {
                // 追加setTimeout 0的操作，防止由于异步加载的原因出现问题
                setTimeout(function () {
                    if (_this && typeof _this.onResume === 'function') {
                        _this.onResume();
                    }
                }, 0);
            };
            ireader.call('registerOnResume', {
                enable: true
            });
        }
    };
}

function sdd () {
    return {
        data: function () {
            return {
                sdd: {}
            };
        },
        created: function () {
            this.$getConfigSdd();
        },
        methods: {
            $getSddUrl: function () {
                var sddUrl = '';
                // 从window属性上获取
                // sddUrl = window.__SDD_DATA_URL__
                // 从dom的data - 属性上获取
                var body = window.document.body;
                sddUrl = body.getAttribute('data-sdd-url');
                return sddUrl;
            },
            $getConfigSdd: function () {
                return __awaiter(this, void 0, void 0, function () {
                    var sddUrl, res, e_1;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                sddUrl = this.$getSddUrl();
                                if (!sddUrl) {
                                    return [2 /*return*/];
                                }
                                _a.label = 1;
                            case 1:
                                _a.trys.push([1, 3, , 4]);
                                return [4 /*yield*/, Sdd.get(sddUrl)];
                            case 2:
                                res = _a.sent();
                                this.sdd = res;
                                return [3 /*break*/, 4];
                            case 3:
                                e_1 = _a.sent();
                                // 上报
                                console.log(e_1);
                                return [3 /*break*/, 4];
                            case 4: return [2 /*return*/];
                        }
                    });
                });
            },
            $getSdd: function (url) {
                return __awaiter(this, void 0, void 0, function () {
                    var res;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                if (!url) {
                                    // eslint-disable-next-line prefer-promise-reject-errors
                                    return [2 /*return*/, Promise.reject({ url: '缺少请求地址' })];
                                }
                                return [4 /*yield*/, Sdd.get(url)];
                            case 1:
                                res = _a.sent();
                                return [2 /*return*/, res];
                        }
                    });
                });
            }
        }
    };
}

var index$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  reachBottom: reachBottom,
  registerOnResume: onResume,
  sdd: sdd
});

var _typeof$1 = {exports: {}};

(function (module) {
  function _typeof(obj) {
    "@babel/helpers - typeof";

    return (module.exports = _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
      return typeof obj;
    } : function (obj) {
      return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports), _typeof(obj);
  }

  module.exports = _typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;
})(_typeof$1);

var _typeof = /*@__PURE__*/getDefaultExportFromCjs(_typeof$1.exports);

(function () {
  var normalizeNonFiniteValue = function normalizeNonFiniteValue(value) {
    value = +value;
    return isNaN(value) || value == Infinity || value == -Infinity ? 0 : value;
  };

  var isBodyPotentiallyScrollable = function isBodyPotentiallyScrollable(body) {
    body = body ? body : document.getElementsByTagName("BODY")[0];
    var bodyComputedStyle = window.getComputedStyle(body);
    var parentComputedStyle = window.getComputedStyle(body.parent);
    var bodyComputedOverflowX = bodyComputedStyle.overflowX;
    var bodyComputedOverflowY = bodyComputedStyle.overflowY;
    var parentComputedOverflowX = parentComputedStyle.overflowX;
    var parentComputedOverflowY = parentComputedStyle.overflowY;
    return (bodyComputedStyle.display == "table-column" || bodyComputedStyle.display == "table-column-group") && parentComputedOverflowX != "visible" && parentComputedOverflowX != "clip" && parentComputedOverflowY != "visible" && parentComputedOverflowY != "clip" && bodyComputedOverflowX != "visible" && bodyComputedOverflowX != "clip" && bodyComputedOverflowY != "visible" && bodyComputedOverflowY != "clip";
  };

  if (!Element.prototype.scroll) {
    Element.prototype.scroll = function () {
      var argsLength = arguments.length;
      var doc = this.ownerDocument;
      var win = doc.defaultView;
      var quirksMode = doc.compatMode == "BackCompat";
      var body = document.getElementsByTagName("BODY")[0];
      var options = {};
      var x, y;
      if (doc != window.document) return;
      if (!win) return;

      if (argsLength === 0) {
        return;
      } else if (argsLength === 1) {
        var arg = arguments[0];
        if (_typeof(arg) != "object") throw "Failed to execute 'scrollBy' on 'Element': parameter 1 ('options') is not an object.";

        if ('left' in arg) {
          options.left = normalizeNonFiniteValue(arg.left);
        }

        if ('top' in arg) {
          options.top = normalizeNonFiniteValue(arg.top);
        }

        x = 'left' in options ? options.left : this.scrollLeft;
        y = 'top' in options ? options.top : this.scrollTop;
      } else {
        options.left = x = normalizeNonFiniteValue(arguments[0]);
        options.top = y = normalizeNonFiniteValue(arguments[1]);
      }

      if (this == document.documentElement) {
        if (quirksMode) return;
        win.scroll('scrollX' in win ? win.scrollX : 'pageXOffset' in win ? win.pageXOffset : this.scrollLeft, y);
        return;
      }

      if (this == body && quirksMode && !isBodyPotentiallyScrollable(body)) {
        win.scroll(options.left, options.top);
        return;
      }

      this.scrollLeft = x;
      this.scrollTop = y;
    };
  }

  if (!Element.prototype.scrollTo) {
    Element.prototype.scrollTo = Element.prototype.scroll;
  }

  if (!Element.prototype.scrollBy) {
    Element.prototype.scrollBy = function () {
      var argsLength = arguments.length;
      var options = {};

      if (argsLength === 0) {
        return;
      } else if (argsLength === 1) {
        var arg = arguments[0];
        if (_typeof(arg) != "object") throw "Failed to execute 'scrollBy' on 'Element': parameter 1 ('options') is not an object.";

        if ('left' in arg) {
          options.left = normalizeNonFiniteValue(arg.left);
        }

        if ('top' in arg) {
          options.top = normalizeNonFiniteValue(arg.top);
        }
      } else {
        options.left = normalizeNonFiniteValue(arguments[0]);
        options.top = normalizeNonFiniteValue(arguments[1]);
      }

      options.left = 'left' in options ? options.left + this.scrollLeft : this.scrollLeft;
      options.top = 'top' in options ? options.top + this.scrollTop : this.scrollTop;
      this.scroll(options);
    };
  }
})();

var stopToggleScreen = {
    bind: function (el) {
        el.addEventListener('touchstart', function () {
            ireader.setEnableThreeScreen({ isEnable: false })["catch"](function (err) {
                console.log(err);
            });
        });
        el.addEventListener('touchend', function () {
            ireader.setEnableThreeScreen({ isEnable: true })["catch"](function (err) {
                console.log(err);
            });
        });
    }
};

var index = /*#__PURE__*/Object.freeze({
  __proto__: null,
  stopToggleScreen: stopToggleScreen
});

export { Device, index as Directives, LOG_LEVEL, index$1 as Mixins, Router, Sdd, Sign, Storage, Trace, Url };
